import React from 'react';

export default class Faq1 extends React.Component{
  constructor(props){
      super(props);
      this.state = { open: false };
      this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e) {
    e.preventDefault();
    this.setState(
      {
        open: !this.state.open
      }
    );
  }

  render(){
    return(
      <div className={`${this.state.open ? 'ativo' : ''} faq-item`}>
        <a className='faq-title' href='#' onClick={this.clickHandler}>
          <span>Como fazer mudança de plano do cliente?</span>
          <i className='fas fa-chevron-down'></i>
        </a>
        <div className='faq-box'>
          <ul className='list-faq'>
            <li>1 - No menu entre na aba clientes</li>
            <li>2 - Busque pelo cliente desejado</li>
            <li>3 - Clique no botão de detalhe do cliente</li>
            <li>4 - Cancele o plano do cliente</li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/faq/Faq1.js